/** Optional buyer note on a play (name of who wagered, etc.). */

export const BUYER_NOTE_MAX_LENGTH = 80;

/** Trim and cap length. Empty after trim becomes undefined. */
export function sanitizeBuyerNote(raw: unknown): string | undefined {
  if (raw == null) return undefined;
  const note = String(raw).replace(/\s+/g, ' ').trim();
  if (!note) return undefined;
  return note.slice(0, BUYER_NOTE_MAX_LENGTH);
}
